/* eslint-disable react/jsx-filename-extension */
import React, { useContext } from 'react';
import Link from 'next/link';
import { CallTo, MailTo } from 'components/common';
import { newsletterFormScrollRef } from 'components/partials/footer/FooterForm';
import { PaymentContext } from 'contexts/paymentContext';
import { paymentConsts } from 'constants/payment';
import maskAmount from 'utils/maskAmount';

const useFaqContent = () => {
  const { paymentData } = useContext(PaymentContext);

  const content = {
    buyers: [
      {
        title: 'Site Hakkında',
        materials: [
          {
            title: 'iyiMakina.com Nedir?',
            content: (
              <>
                <p>
                  iyiMakina, ikinci el iş makinası satış süreçlerini açık artırma kavramı üzerinden optimize edip taraflar için hızlı, adil, güvenilir ve verimli sonuç yaratan Türkiye’nin ilk ve tek online pazaryeri platformudur.
                </p>
                <p>
                  Detaylı ekspertiz raporlarını inceleyerek ikinci el iş makinalarına doğru teklifi verirsiniz.
                  Online açık artırmada en iyi teklifi veren kullanıcı makinayı satın almaya hak kazanır.
                  Olduğu gibi, olduğu yerden makina satış süreçlerini optimize eden iyiMakina.com; alıcılar için uygun fiyatla makina almanın en güvenilir yoludur.
                </p>
                <p>
                  iyiMakina.com'a üye olarak satın almak istediğiniz makinanın açık artırmasına katılabilir, en iyi teklifi vererek makina sahibi olabilirsiniz.
                  Ücretsiz üye olmak için
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Çağrı merkezine hangi saatlerde ulaşabilirim?',
            content: (
              <>
                <p>
                  Her türlü soru ve bilgi talebiniz için
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasından
                  {' '}
                  <b>Pazartesi’den Cumartesi’ye</b>
                  {' '}
                  kadar 09:00-18:00 saatleri arasında Çağrı Merkezimize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'iyiMakina.com’a güvenebilir miyim?',
            content: (
              <>
                <p>
                  iyiMakina.com kullanıcılarına şeffaf ve güvenilir bir alım-satım ortamı sunmayı hedeflemektedir.
                  Bunun için; iyiMakina.com'da satışa çıkarılan makinalar, satış öncesi detaylı bir incelemeden geçer.
                  Ekspertiz raporunda yer alan detaylı bilgileri kullanıcılarımız açık artırma öncesinde ücretsiz olarak inceleyebilirler.
                </p>
                <p>
                  Açık artırmanın güvenliğini sağlamak ve makinaların satış fiyatında yapılabilecek manipülasyonları engellemek amacıyla iyiMakina.com, açık artırmaya katılmak isteyen bütün kullanıcılardan Teminat Bedeli talep eder.
                  Tüm kullanıcılardan alınan Teminat Bedeli aynıdır. Teminat bedelinin alınmasının amacı kullanıcılara adil bir alış-satış ortamı sunmaktır.
                </p>
              </>
            ),
          },
          {
            title: 'iyiMakina.com’dan nasıl makina satın alabilirim?',
            content: (
              <>
                <p>
                  iyiMakina.com üzerinden makina satın almak için üye olmanız gerekmektedir.
                  Üye olduktan sonra makinanızı satışa çıkarabilir ya da açık artırmada olan makinaları kolayca satın alabilirsiniz.
                  Pazarlık Usulü Açık Artırma yöntemi ile makina satın almak için makina detay sayfasına girip “Teklif Ver” butonuna tıklamanız gerekir.
                  En yüksek teklifi veren kullanıcı olmanız durumunda makinanın sahibi olmaya hak kazanırsınız ya da “Hemen Al” teklifi vererek gelen onay kodunu yazmanız dahilinde anında makina sahibi olabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Herkes iyiMakina.com üzerinden makina alıp satabilir mi?',
            content: (
              <>
                <p>
                  iyiMakina.com'a üye olan herkes, güvenilir ve hızlı şekilde makina alıp satabilmektedir. Ücretsiz üye olmak için
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmalardan nasıl haberdar olabilirim?',
            content: (
              <>
                <p>
                  Düzenlediğimiz açık artırmaların bilgisine ulaşmak için
                  {' '}
                  <a
                    onClick={() => {
                      newsletterFormScrollRef?.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      });
                    }}
                  >
                    buraya
                  </a>
                  {' '}
                  tıklayarak, e-mail bültenimize ücretsiz abone olabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Üyelik İşlemleri',
        materials: [
          {
            title: 'Üyelik ücretli mi? Üye olmak için ne yapmalıyım? ',
            content: (
              <>
                <p>
                  iyiMakina.com’a üye olmak ücretsizdir.
                  {' '}
                  <Link href="/register/membership-type">
                    Buraya
                  </Link>
                  {' '}
                  tıklayarak, üyelik sayfasına ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Üye olmak için gerekli evraklar ve koşullar nelerdir?',
            content: (
              <>
                <p>
                  iyiMakina.com’a üye olmak için herhangi bir koşul ve evrak gerekmemektedir. İş makinası alıp satmak isteyen her kullanıcı platformumuza üye olabilmektedir.
                </p>
              </>
            ),
          },
          {
            title: 'Üye olurken neden cep telefonu numarası istiyorsunuz?',
            content: (
              <>
                <p>Kimlik doğrulamasını sağlamak ve güvenli alım-satım ortamı yaratmak için SMS aktivasyonu yapmamız gerekmektedir.</p>
              </>
            ),
          },
          {
            title: 'Aktivasyon Kodu/Sms’i gelmedi ne yapmalıyım?',
            content: (
              <>
                <p>Aktivasyon Kodu/SMS gelmediği takdirde aktivasyon sayfasındaki “Doğrulama Kodu Ulaşmadı mı?” butonuna basarak kodun tekrar gelmesini sağlayabilirsiniz.</p>
                <p>
                  Sorun yaşamaya devam ediyorsanız;
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasından çağrı merkezimize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Online Alım Süreci',
        materials: [
          {
            title: 'Bilgisayardan teklif verebilir miyim?',
            content: (
              <>
                <p>
                  Bilgisayar, tablet ve telefon üzerinden tek tıkla teklif verebilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmalar nerede yapılır?',
            content: (
              <>
                <p>
                  Satıcılar olduğu gibi olduğu yerden makinaları ile aylık açık artırmalara katılabilirler.
                  Teklifler, Türkiye’nin her yerinden alıcıların katılabilmesi için online olarak verilir.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmaya nasıl katılırım?',
            content: (
              <>
                <p>
                  iyiMakina.com’daki açık artırmalara katılmak için öncelikle üye olmanız gerekmektedir.
                  Üye olan kullanıcılar, teminat bedelini ödedikten sonra açık artırmaya katılabilirler.
                </p>
              </>
            ),
          },
          {
            title: 'Teminat Bedeli Nedir?',
            content: (
              <>
                <p>
                  Kredi kartınız veya havale yoluyla açık artırmaya katılmak için ödeyeceğiniz tutara Teminat Bedeli denir.
                  Sisteme bakiye olarak yüklenen Teminat Bedeli ile açık artırmalara katılarak istediğiniz makinaya istediğiniz teklifi verebilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Neden Teminat Bedeli yatırmam gerekiyor?',
            content: (
              <>
                <p>
                  iyiMakina.com, açık artırmaların güvenliğini sağlamak ve makinaların satış fiyatında yapılabilecek manipülasyonları engellemek amacıyla,
                  açık artırmaya katılmak isteyen bütün kullanıcılardan Teminat Bedeli talep eder.
                </p>
                <p>
                  Tüm kullanıcılardan alınan Teminat Bedeli aynıdır. Teminat Bedelinin alınmasının amacı kullanıcılara adil bir satış ortamı sunmaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Teminat Bedelini iade ediyor musunuz?',
            content: (
              <>
                <p>
                  Teminat Bedelini istediğiniz zaman, kesintisiz olarak iade alabilirsiniz. İnternet sitemiz üzerinden Teminat Bedeli İade Talebi oluşturduğunuz takdirde, iadeniz 3 iş günü içerisinde gerçekleşecektir.
                </p>
              </>
            ),
          },
          {
            title: 'Teminat Bedelini ödedim. Şimdi ne olacak?',
            content: (
              <>
                <p>Teminat bedelini ödedikten sonra satın almak istediğiniz makinaya açık artırma teklifi verebileceksiniz.</p>
                <p>Teminat bedeli ödenen aynı gün içerisinde iyiMakina.com müşteri temsilciniz sizinle iletişime geçecektir.</p>
              </>
            ),
          },
          {
            title: 'Teklif Limiti nedir?',
            content: (
              <>
                <p>
                  Teminat bedeli ödeyen tüm katılımcılara, sistem tarafından otomatik olarak 300.000 EURO teklif limiti tanımlanır.
                  Teklif limitiniz dahilinde; birden fazla makinaya teklif verebilirsiniz.
                  Örneğin; Teklif limitiniz 300.000 Euro iken açık artırmaya katılıp 130.000 Euro teklif verdiğinizde; Teklif limitiniz 170.000 Euro olarak gözükecektir.
                </p>
              </>
            ),
          },
          {
            title: 'Teklif Limitimi nasıl artırabilirim?',
            content: (
              <>
                <p>
                  Teklif limitini “Hesabıma Git” kısmındaki “Limit Arttır” butonuna tıklayarak açılan ödeme sayfasından ödeme yaparak artırabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Hangi durumlarda Teminat Bedeli iade edilmez?',
            content: (
              <>
                <p>
                  iyiMakina.com’daki açık artırmalara teklif veren kullanıcılar, açık artırma süresince teminat bedeli iade talebinde bulunurlarsa teminat bedeli iadesi yapılmaz.
                </p>
              </>
            ),
          },
          {
            title: 'Rezerv fiyat hangi açık artırmalarda uygulanır?',
            content: (
              <>
                <p>
                  iyiMakina.com’daki açık artırmalarda sergilenen tüm makinaların rezerv fiyatı vardır.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırma ile ilgili soruları kim yanıtlayabilir?',
            content: (
              <>
                <p>
                  Müşteri Hizmetleri Temsilcilerimiz size yardımcı olmaya hazırdır.
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  'i arayın, sorularınızı yanıtlamak için elimizden geleni yapalım.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmadaki fiyatlar KDV dahil fiyatlar mıdır?',
            content: (
              <>
                <p>
                  Açık artırmada sergilenen makina fiyatlarında KDV fiyatı dahil edilmemiştir.
                  Satış fiyatı üzerinden ikinci el iş makinası KDV oranlarına göre belirlenen KDV dahil edilerek faturalandırılır.
                  Örneğin; ikinci el ekskavatör için nihai fiyat üzerine %8 KDV eklenirken, ikinci el silindir satın alımlarında bu oran %18 olarak belirlenmiştir.
                </p>
              </>
            ),
          },
          {
            title: 'En yüksek teklifi vererek makinayı satın almaya hak kazanırsam verdiğim teklif dışında ayrıca bir ücret tahsil edilecek mi?',
            content: (
              <>
                <p>
                  Nihai satış fiyatının yanı sıra, her üründen %
                  {paymentData.platformUsageFeePercentage}
                  {' '}
                  (
                  {maskAmount(paymentConsts.PLATFORM_USAGE_FEE_MINIMUM_EUR, undefined, true)}
                  {' '}
                  Euro’dan az olmamak şartıyla) platform kullanım ücreti alınacaktır.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Ekspertiz',
        materials: [
          {
            title: 'Satıştaki makinayı yerinde/konumunda görebilir miyim?',
            content: (
              <>
                <p>iyiMakina.com aracılığıyla satışa çıkarılan makinaları yerinde/konumunda görmek için randevu talep etmeniz gerekmektedir.</p>
                <p>
                  Randevu ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasından ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Ekspertiz raporları neleri kapsıyor?',
            content: (
              <>
                <p>
                  Türkiye temsilcisi tarafından yapılan bağımsız ekspertiz incelemesi, ikinci ise iyiMakina'nın uzman ekibi tarafından kayda alınan genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videoyu kapsayan çalışmadır.
                </p>
              </>
            ),
          },
          {
            title: 'Satın almak istediğim makina ile ilgili sorularım var. Kime sorabilirim?',
            content: (
              <>
                <p>
                  Satın almak istediğiniz makinalar ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasından ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Devir İşlemleri ve Ödeme',
        materials: [
          {
            title: 'Ödemeyi nereden ve nasıl yapabilirim? Hangi evraklara ihtiyacım olacak?',
            content: (
              <>
                <p>
                  Açık artırmasını kazandığınız makinanın ödemesini banka hesaplarımıza havale/eft olarak yapabilirsiniz.
                  Alım işlemleri için; Vergi Levhası, İmza Sirküleri, Alım Vekaletnamesi ve Sözleşmenin tarafımıza iletilmesi gerekmektedir.
                </p>
                <p>
                  Makinaların evrak ihtiyacıyla ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasından ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmayı kazandım. Ödemeyi ne zamana kadar yapmalıyım?',
            content: (
              <>
                <p>
                  Kazandığınız açık artırmanın bütün ödemesini
                  {' '}
                  <b> 5 iş günü </b>
                  {' '}
                  içerisinde ödemeniz gerekmektedir.
                  {' '}
                  <b> 5 iş günü </b>
                  {' '}
                  içerisinde ödemenin tamamı yapılmayan makinalarda gecikme ücreti tahsil edilecektir.
                </p>
              </>
            ),
          },
          {
            title: 'Ödeme işlemini tamamlamak ne kadar sürer?',
            content: (
              <>
                <p>
                  Telefonunuza gelen onay kodunu girerek ödemeyi tamamlayabilirsiniz. Bu işlem yaklaşık 5 dakika sürmektedir.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmayı kazandım. Makinanın devrini nasıl alacağım, ne kadar sürüyor?',
            content: (
              <>
                <p>
                  Satın alınan makinaların devri iyiMakina Bilgi Teknolojileri ve Ticaret A.Ş. üzerinden yapılacaktır.
                  Alım işlemleri için; Vergi Levhası, İmza Sirküleri, Alım Vekaletnamesi ve Sözleşmenin tarafımıza iletilmesi gerekmektedir.
                  Makinanın ödemesinin tamamı yapılıp, gerekli evraklar iyiMakina.com'a ulaştırıldığı takdirde, ertesi güne kadar
                  satış işlemleri tamamlanabilmektedir.
                </p>
                <p>
                  Devir süreciyle ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Ödeme işlemi tamamlanmazsa ne olur?',
            content: (
              <>
                <p>
                  Lütfen
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak müşteri hizmetlerine bağlanın.
                </p>
              </>
            ),
          },
          {
            title: 'Aynı anda birden fazla makina satın alabilir miyim?',
            content: (
              <>
                <p>
                  Teklif üst limitiniz dahilinde birden fazla makina satın alabilirsiniz.
                  Teklif verme limitini artırmak için sistem üzerinden “Limit Artır” butonuna tıklayarak teklif üst limitinizi kolayca artırabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Satış işlemini tamamladıktan sonra adres değişikliği yapabilir miyim?',
            content: (
              <>
                <p>
                  Ödeme işleminin tamamını gerçekleştirdikten sonra herhangi bir değişikliği kendiniz yapamazsınız.
                  Lütfen
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak müşteri hizmetlerine bağlanın.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmayı kazandım. 5 iş günü içerisinde ödeme yapmazsam ne olur?',
            content: (
              <>
                <p>
                  5 iş günü içerisinde ödemenin tamamı yapılmayan makinalarda gecikme ücreti tahsil edilecektir.
                  Lütfen
                  {' '}
                  <CallTo tel="+90 850 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak müşteri hizmetlerine bağlanın.
                </p>
              </>
            ),
          },
          {
            title: 'Hangi para birimi ile ödeme yapabilirim?',
            content: (
              <>
                <p>
                  Açık artırmada sergilenen makinaların para birimine göre ödeme yapmanız gerekmektedir.
                  iyiMakina platformunda satışa çıkarılan makinalar satıcının tercihi doğrultusunsa
                  {' '}
                  <b>TL</b>
                  {' '}
                  ve
                  {' '}
                  <b>EURO</b>
                  {' '}
                  birimleriyle satışa çıkarılabilir.
                </p>
              </>
            ),
          },
          {
            title: 'KDV ödemek zorunda kalacak mıyım?',
            content: (
              <>
                <p>
                  Satış fiyatı üzerinden ikinci el iş makinası KDV oranlarına göre belirlenen KDV dahil edilerek faturalandırılır.
                  Örneğin; ikinci el ekskavatör için nihai fiyat üzerine %8 KDV eklenirken, ikinci el silindir satın alımlarında bu oran %18 olarak belirlenmiştir.
                  Platform kullanım ücreti KDV'den muaftır.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Nakliye',
        materials: [
          {
            title: 'Satılan makinaların nakliyesi kimin sorumluluğunda?',
            content: (
              <>
                <p>
                  Satılan makinaların nakliye sorumluluğu
                  {' '}
                  <b>Alıcıya</b>
                  {' '}
                  aittir. Satıcı ve iyiMakina.com’un
                  nakliye ile ilgili bir sorumluluğu yoktur.
                </p>
              </>
            ),
          },
          {
            title: 'Satın aldığım makinanın nakliyesi için ne kadar sürem var?',
            content: (
              <>
                <p>
                  Alıcı, satın aldığı makinanın tüm ödemesini yaptıktan sonraki 8 gün içerisinde makinayı bulunduğu lokasyondan almak durumundadır.
                  8 gün içerisinde alınmayan makinanın, teslim alınmadığı her gün için gecikme ücreti tahsil edilecektir.
                  60 günden fazla nakliyesi yapılmayan makinaların satın alma hakkı iptal olacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Satıcı nakliye için makina ataşman vb. makina teçhizat sökümü yapacak mı?',
            content: (
              <>
                <p>
                  Satıcı ve iyiMakina.com’un nakliye ile ilgili bir sorumluluğu yoktur.
                  Satıcının bir konteynere herhangi bir ataşman vb. makina teçhizatı yüklemek zorunda değildir.
                  Satın alınan makinanın nakliye işlemlerinden alıcı sorumludur.
                  Alıcı, tüm taleplerini satıcı veya nakliye firmalarına iletebilir.
                  Satın alınan makinanın tüm ödeme işlemleri yapıldıktan sonra satıcı bilgileri alıcı ile paylaşılacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Makinanın boyutlarını/teknik özelliklerini nereden öğrenebilirim?',
            content: (
              <>
                <p>
                  iyiMakina.com’daki makina ekspertiz raporunda sergilenen makinalar için ölçü bilgisi paylaşılmamaktadır.
                  Alıcılar, satın alacakları makinaların, marka ve modelinin fabrika çıkışı bilgilerini baz alarak fiziksel ölçülerini tespit etme sorumluluğundadır.
                </p>
                <p>
                  Satıcı ek bilgiler ile size yardımcı olmayı seçebilir, ancak satıcının makina hakkında herhangi bir ek bilgi verme zorunluluğu yoktur.
                </p>
              </>
            ),
          },
          {
            title: 'Teslim almak için satıcı ile nasıl iletişime geçebilirim?',
            content: (
              <>
                <p>
                  iyiMakina.com müşteri temsilcilerimiz, satın alınan makinanın tüm ödemesi yapıldıktan sonra satıcı bilgilerini sizinle paylaşacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Satın aldığım makinaları uluslararası nakliye yapabilir miyim?',
            content: (
              <>
                <p>
                  Satın alınan makinaların nakliye sorumluluğu alıcıya aittir. Teslim aldığınız makinaları dilediğiniz lokasyona nakliyat yapabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
    ],
    sellers: [
      {
        title: 'Site Hakkında',
        materials: [
          {
            title: 'iyiMakina.com Nedir?',
            content: (
              <>
                <p>
                  iyiMakina, ikinci el iş makinası satış süreçlerini açık artırma kavramı üzerinden optimize edip taraflar için hızlı, adil, güvenilir ve verimli sonuç yaratan Türkiye’nin ilk ve tek online pazaryeri platformudur.
                </p>
                <p>
                  Online açık artırmada en iyi teklifi veren kullanıcı makinayı satın almaya hak kazanır.
                  Olduğu gibi, olduğu yerden makina satış süreçlerini optimize eden iyiMakina.com; satıcılar için piyasa değerinde makina satmanın en güvenilir yoludur.
                </p>
                <p>
                  iyiMakina.com'a üye olarak satmak istediğiniz makinayı açık artırmada sergileyerek; piyasa değerinde makinanızı kolay, hızlı ve güvenilir bir şekilde satabilirsiniz.
                  Ücretsiz üye olmak için
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Çağrı merkezine hangi saatlerde ulaşabilirim?',
            content: (
              <>
                <p>
                  Her türlü soru ve bilgi talebiniz için
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasından
                  {' '}
                  <b>Pazartesi’den Cumartesi’ye</b>
                  {' '}
                  kadar 09:00-18:00 saatleri arasında Çağrı Merkezimize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'iyiMakina.com’a güvenebilir miyim?',
            content: (
              <>
                <p>
                  iyiMakina.com kullanıcılarına şeffaf ve güvenilir bir alım-satım ortamı sunmayı hedeflemektedir.
                  Bunun için; iyiMakina.com'da satışa çıkarılan makinalar, satış öncesi detaylı bir incelemeden geçer.
                  Ekspertiz raporunda yer alan detaylı bilgileri kullanıcılarımız açık artırma öncesinde ücretsiz olarak inceleyebilirler.
                </p>
                <p>
                  Açık artırmanın güvenliğini sağlamak ve makinaların satış fiyatında yapılabilecek manipülasyonları engellemek amacıyla iyiMakina.com, açık artırmaya katılmak isteyen bütün kullanıcılardan Teminat Bedeli talep eder.
                  Tüm kullanıcılardan alınan Teminat Bedeli aynıdır.
                  Teminat bedelinin alınmasının amacı kullanıcılara adil bir alış-satış ortamı sunmaktır.
                </p>
              </>
            ),
          },
          {
            title: 'iyiMakina.com’da nasıl makina satılır?',
            content: (
              <>
                <p>
                  iyiMakina.com üzerinden makina satmak için Makinamı Satmak İstiyorum formunu doldurmanız gerekmektedir.
                  Makinamı Satmak İstiyorum formunu dolduran kullanıcılar müşteri temsilcimiz tarafından ulaşılarak süreç hakkında ayrıca bilgilendirme yapılacaktır.
                </p>
                <p>
                  “Pazarlık Usulü Açık Artırma” ya da “Zaman Ayarlı Açık Artırma” yöntemi ile makinanızı satabilirsiniz.
                  “Pazarlık Usulü Açık Artırma” yönteminde belirlediğiniz “Hemen Al” fiyatını veren ilk kullanıcı makinanın sahibi olur.
                  “Zaman Ayarlı Açık Artırma” yönteminde ise açık artırma bittiğinde en yüksek teklifi veren kullanıcı, makina rezerv fiyatının üstünde teklif vermiş ise makinanın sahibi olmaya hak kazanır.
                </p>
              </>
            ),
          },
          {
            title: 'Herkes iyiMakina.com üzerinden makina alıp satabilir mi?',
            content: (
              <>
                <p>
                  iyiMakina.com'a üye olan herkes, güvenilir ve hızlı şekilde makina alıp satabilmektedir. Ücretsiz üye olmak için
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırmalardan nasıl haberdar olabilirim?',
            content: (
              <>
                <p>
                  Düzenlediğimiz açık artırmaların bilgisine ulaşmak için
                  {' '}
                  <a
                    onClick={() => {
                      newsletterFormScrollRef?.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      });
                    }}
                  >
                    buraya
                  </a>
                  {' '}
                  tıklayarak, e-mail bültenimize ücretsiz abone olabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Üyelik İşlemleri',
        materials: [
          {
            title: 'Üyelik ücretli mi? Üye olmak için ne yapmalıyım?',
            content: (
              <>
                <p>
                  İyiMakina.com’a üye olmak ücretsizdir.
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayarak, üyelik sayfasına ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Üye olmak için gerekli evraklar ve koşullar nelerdir?',
            content: (
              <>
                <p>iyiMakina.com’a üye olmak için herhangi bir koşul ve evrak gerekmemektedir. İş makinası alıp satmak isteyen her kullanıcı platformumuza üye olabilmektedir.</p>
              </>
            ),
          },
          {
            title: 'Üye olmak ne kadar sürüyor?',
            content: (
              <>
                <p>
                  iyiMakina.com’a mail adresiniz ve cep telefonu numaranızla
                  {' '}
                  <b>5 dakika </b>
                  {' '}
                  içinde ücretsiz üye olabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Üye olurken neden cep telefonu numarası istiyorsunuz?',
            content: (
              <>
                <p>Kimlik doğrulamasını sağlamak ve güvenli alım-satım ortamı yaratmak için SMS aktivasyonu yapmamız gerekmektedir.</p>
              </>
            ),
          },
          {
            title: 'Aktivasyon Kodu/Sms’i gelmedi ne yapmalıyım?',
            content: (
              <>
                <p>Aktivasyon Kodu/Sms gelmediği takdirde aktivasyon sayfasındaki “Doğrulama Kodu Ulaşmadı mı?” butonuna basarak kodun tekrar gelmesini sağlayabilirsiniz.</p>
                <p>
                  Sorun yaşamaya devam ediyorsanız;
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasından çağrı merkezimize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Online Satış Süreci',
        materials: [
          {
            title: 'Açık artırmalar nerede yapılacak?',
            content: (
              <>
                <p>
                  iyiMakina.com’da satışa çıkan tüm makinalar, online olarak satılır.
                  Makinanız olduğu gibi, olduğu yerden açık artırmada sergilenir.
                  Tek tıkla Türkiye’nin her yerinden teklif veren alıcılar, kolayca makina sahibi olurlar.
                </p>
              </>
            ),
          },
          {
            title: 'Makinamı satmaya karar verdim. Rezerv fiyat belirleyebiliyor muyum?',
            content: (
              <>
                <p>
                  Makinanızın minimum satış fiyatını belirleyebilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Gelen en yüksek teklif rezerv fiyat geçmez ise ne olacak?',
            content: (
              <>
                <p>
                  Açık artırma sonunda gelen en yüksek teklif makinanızın minimum fiyatının altında ise; makinanız diğer ayki açık artırmada sergilenir.
                  “Pazarlık Usulü Açık Artırma” yöntemiyle satışa çıkan makinalarda platform üzerinden en yüksek teklifi veren kullanıcı ile pazarlık yapabilir ve gelen teklifleri; kabul edebilir, reddedebilir ve ya karşı teklifte bulunabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Makinamı satmaya karar verdim. Satış formunu doldurmam gerekli mi?',
            content: (
              <>
                <p>
                  Makinanızı satmaya karar verdiğinizde, “Makinamı Satmak İstiyorum” formunu doldurarak makinanızı satmak istediğinizi bize iletmiş olursunuz.
                  Müşteri temsilcimiz 1 iş günü içerisinde dönüş sağlayacaktır.
                </p>
              </>
            ),
          },
          {
            title: '“Pazarlık Usulü Açık Artırma” yöntemi nedir?',
            content: (
              <>
                <p>
                  Pazarlık yöntemi ile satışa çıkan makinalar, önceden belirlenmiş fiyatlarıyla birlikte satışa hazır durumdadır.
                  Makinaları satın almak isteyen alıcılar, teklif verebilir ya da makina ilan sayfasında belirtilen "Hemen Al" butonuna tıklar ve belirlenen fiyatı ödeyerek kolayca makina sahibi olabilirler.
                  “Hemen Al” teklifi veren kullanıcılar, açık artırmayı sonlandırabilir.
                </p>
              </>
            ),
          },
          {
            title: '“Zaman Ayarlı Açık Artırma” yöntemi nedir?',
            content: (
              <>
                <p>
                  Zaman Ayarlı Açık Artırma yöntemiyle satışa çıkan makinalar 3 hafta boyunca otomatik teklif alınmak üzere sergilenir, takip eden 1 hafta da açık artırma başlar ve ay sonunda sona erer.
                  Kullanıcılar, makina ilan sayfasındaki "Teklif Ver" butonu ile istedikleri teklifi tek tıkla verip, eş zamanlı rekabet içerisinde istedikleri makinaya sahip olabilirler.
                </p>
              </>
            ),
          },
          {
            title: 'Açık artırma sürecini nasıl takip edebilirim?',
            content: (
              <>
                <p>
                  Satışa çıkan makinanıza gelen teklifler ve gelişmeler anlık olarak mail ve sms yoluyla tarafınıza iletilecektir.
                </p>
              </>
            ),
          },
          {
            title: 'Birden fazla makina satmak istiyorum. Platform kullanım ücretinde bir değişiklik olacak mı?',
            content: (
              <>
                <p>
                  Satmak istediğiniz makinanın adedine ve paket büyüklüğüne göre bu oran değişebilir.
                  Lütfen
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak müşteri hizmetlerine bağlanın.
                </p>
              </>
            ),
          },
          {
            title: 'Makinamın katıldığı açık artırma bitti ve makinama istediğim teklif gelmedi. Ne olacak?',
            content: (
              <>
                <p>
                  iyiMakina.com, satıcının belirttiği fiyat aralığında teklif alamadığı takdirde makinayı en yakın açık artırmaya tekrar dahil edecektir. Münhasırlık sözleşmesi boyunca makinanız her açık artırmaya katılım hakkına sahiptir.
                </p>
              </>
            ),
          },
          {
            title: 'Herkes iyiMakina.com üzerinden makina alıp satabilir mi?',
            content: (
              <>
                <p>
                  iyiMakina.com'a üye olan herkes, güvenilir ve hızlı şekilde makina alıp satabilmektedir.
                  Ücretsiz üye olmak için
                  {' '}
                  <Link href="/register/membership-type">
                    buraya
                  </Link>
                  {' '}
                  tıklayabilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Ekspertiz',
        materials: [
          {
            title: 'Makinamı satmak istiyorum. Ekspertizini iyiMakina mı yapıyor?',
            content: (
              <>
                <p>
                  Makinanın Türkiye temsilcisi tarafından yapılan ekspertiz raporu makina sahipleri tarafından yaptırılır.
                  iyiMakina.com’un uzman ekspertiz ekibi, makinanızı bulunduğu yerde ziyaret ederek, kapsamlı ve detaylı görsel ve işitsel malzemelerle destekleyici bir rapor sunar.
                  Makinanızın kategorisine ve modeline göre yapılan bu destekleyici çalışma için ücret tahsil edilmemektedir.
                </p>
                <p>
                  Ekspertiz süreciyle ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasından ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Ekspertiz raporunuz neleri kapsıyor?',
            content: (
              <>
                <p>
                  Ekspertiz raporları iki ana kısımdan oluşmaktadır.
                  İlki; satılması planlanan makinanın genellikle Türkiye temsilcisi tarafından yapılan bağımsız ekspertiz incelemesi,
                  ikinci ise iyiMakina'nın uzman ekibi tarafından kayda alınan genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videoyu kapsayan çalışmadır.
                </p>
              </>
            ),
          },
          {
            title: 'Ekspertiz randevusu nasıl alırım?',
            content: (
              <>
                <p>
                  Makinanıza ekspertiz randevusu almak için
                  {' '}
                  <Link href="/contact-us">
                    <a>Formumuzu</a>
                  </Link>
                  {' '}
                  doldurabilir ya da
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasını arayarak müşteri hizmetlerinden randevu talep edebilirsiniz.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Devir İşlemleri ve Ödeme',
        materials: [
          {
            title: 'Makinamın satışı tamamlandı. Ödemeyi nasıl alacağım?',
            content: (
              <>
                <p>Makinanızın satış tutarının tamamı satıcı tarafından tarafımıza ödendiği takdirde ödeme tutarı hesabınıza tarafımızca havale/eft yapılacaktır.</p>
              </>
            ),
          },
          {
            title: 'Sattığım makinanın devrini nasıl vereceğim, ne kadar sürüyor?',
            content: (
              <>
                <p>Satılan makinaların devri iyiMakina Bilgi Teknolojileri A.Ş. üzerinden yapılacaktır. Makinanın ödemesinin tamamı yapılıp, gerekli evraklar iyiMakina.com'a ulaştırıldığı takdirde, ertesi güne kadar satış işlemleri tamamlanabilmektedir.</p>
                <p>
                  Devir süreciyle ilgili her türlü soru ve detaylı bilgi almak için
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  irtibat numarasından ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atarak bize ulaşabilirsiniz.
                </p>
              </>
            ),
          },
          {
            title: 'Makinamı satmak ne kadar sürer?',
            content: (
              <>
                <p>
                  iyiMakina.com aracılığıyla satışa çıkan makinalar; doğru alıcıyla, en hızlı ve en iyi fiyatla buluşmaktadır.
                  Güven ve şeffaflık ortamında gerçekleşen, 30 gün süren açık artırmalar sonucunda, makinanız ülke genelinden alıcılarıyla buluşmaktadır.
                </p>
              </>
            ),
          },
          {
            title: 'Makinama en yüksek teklifi veren vazgeçti. Şimdi ne olacak?',
            content: (
              <>
                <p>Açık artırmayı kazanan alıcı satın almaktan vazgeçerse; teminat bedeli iadesi edilmez ve hakkını kaybeder. </p>
                <p>
                  Bu durumda ikinci en yüksek teklifte bulunan alıcı açık artırmayı kazanmış olur. Makina sahibi ikinci en yüksek teklifi kabul ettiği takdirde satış onaylanmış olur.
                </p>
              </>
            ),
          },
          {
            title: 'Noter satış devir ücretleri kimin tarafından karşılanmaktadır?',
            content: (
              <>
                <p>
                  Noter satış devir ücretleri iyiMakina.com tarafından karşılanmaktadır.
                </p>
              </>
            ),
          },
        ],
      },
      {
        title: 'Nakliye',
        materials: [
          {
            title: 'Satılan makinaların nakliyesi kimin sorumluluğunda?',
            content: (
              <>
                <p>
                  Satılan makinaların nakliye sorumluluğu Alıcıya aittir.
                  {' '}
                  <b>Alıcıya</b>
                  ,
                  {' '}
                  gerekli düzenlemeleri yaparak makinayı bulunduğu lokasyondan teslim alacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Sattığım makinanın nakliyesi ne zaman yapılacak?',
            content: (
              <>
                <p>
                  Satın aldığı makinanın tüm ödemesini yapan alıcı, 8 gün içerisinde makinayı bulunduğu lokasyondan almak durumundadır.
                  8 gün alınmayan makinanın teslim alınmadığı her gün için gecikme ücreti tahsil edilecektir.
                  60 günden fazla nakliyesi yapılmayan makinaların satın alma hakkı iptal olacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Satıcı olarak nakliye için makina ataşman vb. makina teçhizat sökümü yapacak mıyım?',
            content: (
              <>
                <p>
                  Satıcı ve iyiMakina.com’un nakliye ile ilgili bir sorumluluğu yoktur.
                  Satıcının bir konteynere herhangi bir ataşman vb. makina teçhizatı yüklemek zorunda değildir.
                  Satın alınan makinanın nakliye işlemlerinden alıcı sorumludur.
                  Alıcı, tüm taleplerini satıcı veya nakliye firmalarına iletebilir.
                  Satın alınan makinanın tüm ödeme işlemleri yapıldıktan sonra satıcı bilgileri alıcı ile paylaşılacaktır.
                </p>
              </>
            ),
          },
          {
            title: 'Makinamı teslim etmek için alıcı ile nasıl iletişime geçebilirim?',
            content: (
              <>
                <p>
                  iyiMakina.com müşteri temsilcilerimiz, makinanın tüm ödemesi yapıldıktan sonra satıcı bilgilerini alıcı ile paylaşacaktır.
                </p>
              </>
            ),
          },
        ],
      },
    ],
  };

  return content;
};

export default useFaqContent;
